import React from "react";
import { FaTimes } from "react-icons/fa";

type CloseModalButtonPropsType = {
  handleClick: () => void;
  className?: string;
};

function CloseModalButton({ handleClick, className = "" }: CloseModalButtonPropsType) {
  return (
    <button
      className={`bg-yellow text-white w-6 h-6  flex items-center justify-center p-0 rounded-md ${className}`}
      onClick={handleClick}
    >
      <FaTimes className="text-sm" />
    </button>
  );
}

export default CloseModalButton;
